export default __webpack_public_path__ + "static/media/close-img.b81ecc40.svg";